import { useState, useEffect, useCallback } from 'react';
import { useDubs } from '../provider';
import type { GameListItem, Pagination, GetNetworkGamesParams, QueryResult } from '../types';

export function useNetworkGames(params?: GetNetworkGamesParams): QueryResult<{ games: GameListItem[]; pagination: Pagination }> {
  const { client } = useDubs();
  const [data, setData] = useState<{ games: GameListItem[]; pagination: Pagination } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const paramKey = JSON.stringify(params ?? {});

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await client.getNetworkGames(params);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, [client, paramKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
